export default () => {
  document.addEventListener('input', (event) => {
    const textarea = event.target

    if (!textarea.matches('.el-textarea__inner')) {
      return
    }

    const wrapper = textarea.closest('.el-textarea')
    if (!wrapper || !wrapper.querySelector('.el-input__count')) {
      return
    }

    if (textarea.selectionEnd !== textarea.value.length) {
      return
    }

    requestAnimationFrame(() => {
      textarea.scrollTop = textarea.scrollHeight
    })
  }, true)
}
